/* Kuori · «Añade un detalle» a la cistella lateral i a la pàgina de la cistella (snippets/kuori-upsell-row.liquid),
   21/10/2026. Substitueix el «Combínalo con» de r19c: ara només accessoris, 2–3 targetes petites amb «+».
   Les dades surten sempre de Shopify (norma LaLiga: cap petició al Daily):
   - sections/kuori-acc-feed.liquid per la Section Rendering API: els accessoris més venuts
     (/collections/accessories?sort_by=best-selling) i els que porten el nom del disseny de la funda (/search?q=…).
   Ordre: 1) a joc (mateix nom de disseny: «Ashley - AirPods Case» amb «Ashley»), 2) mateix color (metacamp
   shopify.color-pattern), 3) més venuts. Res que ja sigui a la cistella ni sense estoc. Accessoris per model:
   protectors només amb el model de mòbil de la funda; fundes d'AirPods només del model d'AirPods si se sap (una funda
   d'AirPods a la cistella o el model recordat «kuori:model»); si no se sap, cal triar-lo abans d'afegir.
   Mesura: Shopify.analytics.publish('kuori_upsell_click', { place, product, source, locale, action }) en cada clic
   a la targeta (action 'click') i en cada afegit (action 'add'). No s'afegeix res a les línies de la comanda.
   En afegir: /cart/add.js i «cart:refresh» (el tema torna a pintar el calaix); a /cart es torna a pintar la secció.
   Al final, la mateixa mesura per al «Complétalo» de la fitxa (place 'pdp'). */
(() => {
  if (customElements.get('kuori-cart-recs')) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const DEV = /^(iPhone|Samsung|Galaxy|Xiaomi|Redmi|Pixel)/i;
  const AIR = /^AirPods/i;
  const MAX = 3;
  const TTL = 600000;
  const mem = {};

  const cacheGet = (k) => {
    if (k in mem) return mem[k];
    try { const v = JSON.parse(sessionStorage.getItem('kacc:' + k)); if (v && Date.now() - v.t < TTL) return (mem[k] = v.d); } catch (e) {}
    return undefined;
  };
  const cacheSet = (k, d) => { mem[k] = d; try { sessionStorage.setItem('kacc:' + k, JSON.stringify({ t: Date.now(), d })); } catch (e) {} };

  // Llista d'accessoris (sections/kuori-acc-feed.liquid) d'una URL de la botiga
  const feed = async (path) => {
    const url = root.replace(/\/$/, '') + path + (path.includes('?') ? '&' : '?') + 'section_id=kuori-acc-feed';
    const c = cacheGet(url); if (c !== undefined) return c;
    try {
      const r = await fetch(url);
      if (!r.ok) return [];
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const list = JSON.parse(doc.querySelector('script[data-kaf]').textContent).filter(Boolean)
        .map((p) => ({ ...p, v: p.v.map(([id, title, o1, price, was, img]) => ({ id, title, o1, price, was, img })) }));
      cacheSet(url, list);
      return list;
    } catch (e) { return []; }
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const low = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  // «Ashley MagSafe» → «Ashley»; «Doggy Love» → «Doggy Love»
  const design = (title) => String(title || '').replace(/\s+MagSafe\b.*$/i, '').replace(/\s+-\s+.*$/, '').trim();
  // «Ashley - AirPods Case», «Doxie Love Charm» són del disseny «Ashley», «Doxie Love»
  const ofDesign = (p, d) => { const t = low(p.title), x = low(d); return x.length > 2 && t.startsWith(x) && /^($|[\s\-–·:])/.test(t.slice(x.length)); };

  const publish = (detail) => {
    try { window.Shopify?.analytics?.publish?.('kuori_upsell_click', detail); } catch (e) {}
  };

  class KuoriCartRecs extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      this.row = this.querySelector('[data-krecs-row]');
      this.msg = this.querySelector('.krecs__msg');
      const sig = JSON.stringify(this.data.items) + root;
      const last = KuoriCartRecs.last;
      if (last && last.sig === sig) this.paint(last.cards); // mateixa cistella: es pinta a l'instant, sense salts
      else this.build().then((cards) => { KuoriCartRecs.last = { sig, cards }; this.paint(cards); });
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
    }

    async build() {
      const items = this.data.items || [];
      const inCart = new Set(items.map((i) => i.handle));
      const pids = new Set(items.map((i) => i.pid));
      const cases = items.filter((i) => i.c); // fundes de mòbil (etiqueta «fundas tough», kuori-upsell-row)
      const phone = (cases.find((i) => DEV.test(i.o1 || '')) || {}).o1 || '';
      let air = (items.find((i) => AIR.test(i.o1 || '')) || {}).o1 || '';
      if (!air) { try { const m = localStorage.getItem('kuori:model') || ''; if (AIR.test(m)) air = m; } catch (e) {} }
      const designs = [...new Set(cases.map((c) => design(c.title)).filter(Boolean))].slice(0, 2);
      const colors = new Set(cases.flatMap((c) => c.colors || []));

      const [best, ...byDesign] = await Promise.all([
        feed('/collections/accessories?sort_by=best-selling'),
        ...designs.map((d) => feed('/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(d))),
      ]);

      const cards = [];
      const used = new Set();
      const take = (p, source) => {
        if (cards.length >= MAX || !p || used.has(p.handle) || inCart.has(p.handle) || pids.has(p.id)) return;
        let v = p.v;
        const o1s = v.map((x) => x.o1 || '');
        let pick = false;
        if (o1s.some((o) => DEV.test(o))) {
          // per model de mòbil (protectors): només si sabem el model i el producte el té
          if (!phone) return;
          v = v.filter((x) => x.o1 === phone);
        } else if (o1s.some((o) => AIR.test(o))) {
          // fundes d'AirPods: mai un model diferent del que sabem; si no el sabem, la clienta el tria
          if (air) v = v.filter((x) => x.o1 === air);
          else pick = v.length > 1;
        }
        if (!v.length) return;
        used.add(p.handle);
        cards.push({ p, v, source, pick, sel: pick ? null : v[0].id });
      };

      // 1. A joc: mateix nom de disseny
      byDesign.forEach((list, i) => list.filter((p) => ofDesign(p, designs[i])).forEach((p) => take(p, 'match')));
      // 2. Mateix color que la funda, entre els més venuts
      if (colors.size) best.filter((p) => !p.gift && (p.colors || []).some((c) => colors.has(c))).forEach((p) => take(p, 'match'));
      // 3. Més venuts (la targeta regal, al final)
      best.filter((p) => !p.gift).forEach((p) => take(p, 'bestseller'));
      best.filter((p) => p.gift).forEach((p) => take(p, 'bestseller'));
      return cards;
    }

    paint(cards) {
      this.cards = cards;
      if (!cards.length) { this.hidden = true; return; }
      const t = this.data.t;
      this.row.innerHTML = cards.map((c, i) => {
        const v = c.v.find((x) => x.id === c.sel) || c.v[0];
        const label = (x) => (c.v.every((y) => y.o1 === x.o1) && x.title.includes(' / ') ? x.title.split(' / ').slice(1).join(' / ') : x.title);
        const opts = c.v.length > 1
          ? `<select class="krec__sel" data-krec-sel aria-label="${esc(t.model)} · ${esc(c.p.title)}">${c.pick ? `<option value="" selected disabled>${esc(t.model)}</option>` : ''}${c.v.map((x) => `<option value="${x.id}"${!c.pick && x.id === v.id ? ' selected' : ''}>${esc(label(x))}</option>`).join('')}</select>`
          : '';
        return `<div class="krec" data-krec="${i}">
          <a class="krec__media" href="${esc(c.p.url)}" data-krec-link tabindex="-1" aria-hidden="true"><img src="${esc(v.img || c.p.img)}" alt="" loading="lazy" width="80" height="80" data-krec-img></a>
          <div class="krec__info">
            <a class="krec__title" href="${esc(c.p.url)}" data-krec-link>${esc(c.p.title)}</a>
            <p class="krec__price">${c.source === 'match' ? `<span class="krec__tag">${esc(t.match)}</span>` : ''}<span data-krec-now>${esc(v.price)}</span> <s data-krec-was${v.was ? '' : ' hidden'}>${esc(v.was)}</s></p>
            ${opts}
          </div>
          <button type="button" class="krec__add" data-krec-add aria-label="${esc(t.add.replace('%name%', c.p.title))}"><svg class="krec__plus" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><svg class="krec__check" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M2 7.5l3.2 3L12 3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
        </div>`;
      }).join('');
      this.hidden = false;
      this.updateNav();
      this.row.addEventListener('scroll', () => this.updateNav(), { passive: true });
      // el calaix es pinta amagat: es torna a calcular quan la fila té mida
      if (window.ResizeObserver && !this._ro) { this._ro = new ResizeObserver(() => this.updateNav()); this._ro.observe(this.row); }
    }

    updateNav() {
      const r = this.row;
      const nav = this.querySelector('.krecs__nav');
      if (!nav) return;
      nav.hidden = !(r.scrollWidth > r.clientWidth + 4);
      const prev = nav.querySelector('[data-krecs-prev]');
      const next = nav.querySelector('[data-krecs-next]');
      if (prev) prev.disabled = Math.abs(r.scrollLeft) < 4;
      if (next) next.disabled = Math.abs(r.scrollLeft) + r.clientWidth >= r.scrollWidth - 4;
    }

    detail(c, action) {
      return { place: this.data.place, product: c.p.handle, source: c.source, locale: this.data.locale || (window.Shopify && Shopify.locale) || '', action };
    }

    onChange(e) {
      const sel = e.target.closest('[data-krec-sel]');
      if (!sel) return;
      const el = sel.closest('[data-krec]');
      const c = this.cards[+el.dataset.krec];
      const v = c.v.find((x) => String(x.id) === sel.value);
      if (!v) return;
      c.sel = v.id;
      el.classList.remove('is-missing');
      this.msg.textContent = '';
      el.querySelector('[data-krec-now]').textContent = v.price;
      const was = el.querySelector('[data-krec-was]');
      was.hidden = !v.was; was.textContent = v.was;
      if (v.img) el.querySelector('[data-krec-img]').src = v.img;
    }

    async onClick(e) {
      const nav = e.target.closest('[data-krecs-prev],[data-krecs-next]');
      if (nav) {
        const dir = nav.hasAttribute('data-krecs-next') ? 1 : -1;
        this.row.scrollBy({ left: dir * this.row.clientWidth * 0.8 * (document.dir === 'rtl' ? -1 : 1), behavior: 'smooth' });
        return;
      }
      const link = e.target.closest('[data-krec-link]');
      if (link) { const c = this.cards[+link.closest('[data-krec]').dataset.krec]; if (c) publish(this.detail(c, 'click')); return; }
      const btn = e.target.closest('[data-krec-add]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      const el = btn.closest('[data-krec]');
      const c = this.cards[+el.dataset.krec];
      publish(this.detail(c, 'click'));
      const id = Number(c.sel);
      if (!id) {
        // funda d'AirPods sense model: primer cal triar-lo
        el.classList.add('is-missing');
        this.msg.textContent = this.data.t.pickAir;
        el.querySelector('[data-krec-sel]')?.focus();
        return;
      }
      btn.setAttribute('aria-busy', 'true');
      el.classList.add('is-busy');
      this.msg.textContent = '';
      try {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        const json = await r.json();
        if (!r.ok) throw new Error(json.description || json.message || 'Error');
        publish(this.detail(c, 'add'));
        el.classList.remove('is-busy');
        el.classList.add('is-added');
        this.msg.textContent = this.data.t.added;
        KuoriCartRecs.last = null;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (this.data.place === 'cart') setTimeout(() => this.refreshCartPage(), 700);
      } catch (err) {
        this.msg.textContent = this.data.t.error;
        btn.removeAttribute('aria-busy');
        el.classList.remove('is-busy');
      }
    }

    // Pàgina /cart: es torna a demanar la secció de la cistella (línies, total i aquesta fila) i se substitueix
    async refreshCartPage() {
      const sec = this.closest('.shopify-section');
      const id = sec && sec.id.replace(/^shopify-section-/, '');
      try {
        if (!id) throw new Error('section');
        const r = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(id)}`);
        if (!r.ok) throw new Error(r.status);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = doc.getElementById(sec.id);
        if (!fresh) throw new Error('section');
        sec.replaceChildren(...[...fresh.childNodes].map((n) => document.importNode(n, true)));
      } catch (e) { window.location.reload(); }
    }
  }
  customElements.define('kuori-cart-recs', KuoriCartRecs);

  /* «Complétalo» de la fitxa (sections/kuori-upsell.liquid + assets/kuori-pdp.js): la mateixa mesura, place 'pdp'.
     Clic a la targeta o a «Añadir»/«Añadir los dos» → action 'click'; quan kuori-pdp.js ha afegit (dispara
     «cart:refresh» només si /cart/add.js ha anat bé) → action 'add' per cada producte. */
  const pdpLocale = () => (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
  const pdpDetail = (it, action) => ({ place: 'pdp', product: it.dataset.kupHandle || '', source: it.dataset.kupSource || 'match', locale: pdpLocale(), action });
  let pdpPending = null;
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-kbox-end] [data-kup-add], [data-kbox-end] [data-kup-both-add], [data-kbox-end] .kup__item a');
    if (!t) return;
    const items = t.matches('[data-kup-both-add]')
      ? [...document.querySelectorAll('[data-kbox-end][data-mounted] [data-kup-item]')]
      : [t.closest('[data-kup-item]')].filter(Boolean);
    items.forEach((it) => publish(pdpDetail(it, 'click')));
    if (!t.matches('a')) pdpPending = { items, at: Date.now() };
  }, true);
  document.documentElement.addEventListener('cart:refresh', () => {
    if (!pdpPending || Date.now() - pdpPending.at > 8000) { pdpPending = null; return; }
    pdpPending.items.forEach((it) => publish(pdpDetail(it, 'add')));
    pdpPending = null;
  });
})();
